import React, { Component } from "react";
import firebase from "../../utils/firebase";

import Button from "@atlaskit/button";
import EditorRemoveIcon from "@atlaskit/icon/glyph/editor/remove";

import "./profileFormAddressCard.css";
export default class ProfileFormAddressCard extends Component {
  handleDeleteAddressClick = addressId =>
    firebase
      .firestore()
      .collection("my")
      .doc(this.props.userContext.user.uid)
      .update({
        [`addresses.${addressId}`]: firebase.firestore.FieldValue.delete()
      });

  render() {
    return (
      <div className="profile-address-card profile-card">
        <h6 className="profile-reference-card__detail">
          {`Address #${this.props.index}`}
        </h6>
        <p className="profile-address-card__detail">
          {this.props.address.address}
        </p>
        <p className="profile-address-card__detail">
          {this.props.address.from} - {this.props.address.to}
        </p>
        <p className="profile-address-card__detail">
          {this.props.address.landlordName} -{" "}
          {this.props.address.landlordTelephone}
        </p>
        <Button
          iconBefore={<EditorRemoveIcon />}
          onClick={() => {
            this.handleDeleteAddressClick(this.props.address.addressId);
          }}
        >
          Delete
        </Button>
      </div>
    );
  }
}

ProfileFormAddressCard.defaultProps = {
  address: {},
  index: ""
};



// WEBPACK FOOTER //
// ./src/components/profileFormAddressCard/ProfileFormAddressCard.js